var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live"},[_c('div',{staticClass:"player"}),_c('LiveFooter',{attrs:{"place":_vm.place,"desc":_vm.desc}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }